"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : LINECHART : STYLES --------------- ++++++++++ */


var _default = {
  linechart: {
    width: function width(props) {
      return props.width ? (0, _index.pxToEm)(props.width) : '100%';
    },
    border: '1px solid rgb(236, 240, 247)',
    borderRadius: (0, _index.pxToEm)(5),
    padding: (0, _index.pxToEm)(10),
    background: _index.theme.color.light.light.swatch,
    transition: 'all .2s ease-in 0s',
    '&:hover': {
      boxShadow: '0px 3px 10px 0px rgb(236, 240, 247)'
    },
    '&.hasDetails-true': {
      cursor: 'pointer'
    },
    '& .data': {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      // justifyContent: 'space-between',
      '& .info': {
        // borderBottom: '1px solid red', // for testing purposes to see where chart meets bottom of title text
        height: (0, _index.pxToEm)(95),
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: (0, _index.replacePXinStringWithEM)("16px 22px 0px"),
        '& .label': {
          marginBottom: (0, _index.pxToEm)(-7),
          fontWeight: "500"
        },
        '& .value': {
          extend: _index.theme.typography.size.xxxlarge,
          fontWeight: "600"
        },
        '& .loading': {
          fontSize: (0, _index.pxToEm)(16),
          marginTop: (0, _index.pxToEm)(16)
        },
        marginBottom: (0, _index.pxToEm)(30)
      },
      '& .visualization': {
        height: function height(props) {
          return props.height ? (0, _index.pxToEm)(props.height) : (0, _index.pxToEm)(150);
        },
        // make sure parent container have a defined height when using responsive component,
        width: '100%',
        // maxWidth: pxToEm(1000),
        position: 'relative',
        '& text': {
          fill: 'rgb(192, 201, 220) !important'
        }
      },
      transition: 'filter .2s ease-in 0s'
    },
    '& .details': {
      textAlign: 'right',
      paddingTop: (0, _index.pxToEm)(16),
      fontWeight: "500"
    },
    // ------- loading state ----------//
    '& .loading': {
      '& .name-loader': {
        height: (0, _index.pxToEm)(16),
        width: (0, _index.pxToEm)(16),
        paddingBottom: (0, _index.pxToEm)(20),
        '& div': {
          borderColor: "".concat(_index.theme.color.primary.medium.swatch, " transparent transparent transparent"),
          borderWidth: (0, _index.pxToEm)(2),
          height: (0, _index.pxToEm)(16),
          width: (0, _index.pxToEm)(16)
        }
      }
    }
  }
};
exports.default = _default;